module.exports = __webpack_public_path__ + "img/daiban.2903874a.png";